import { Injectable } from "@angular/core";

import { QueryStringSerializationService } from "../../../../shared-library/services/environment/query-string-serialization.service";

import { SearchTabAlias } from "../../../enums/search-tab-alias.enum";

import { DirectorySearchParametersModel } from "../models/directory-search-parameters.model";
import { SearchTabConfigModel } from "../models/search-tab-config.model";

@Injectable({
    providedIn: "root"
})
export class DirectorySearchParametersFactoryService {
    public constructor(
        private _serializationService: QueryStringSerializationService
    ) {
    }

    public createFromQueryString(queryString: string, searchTabConfig: SearchTabConfigModel): DirectorySearchParametersModel {
        const rawValues = this._serializationService.deserialize<DirectorySearchParametersModel>(queryString);
        const parsedValues = new DirectorySearchParametersModel();
        parsedValues.searchTab = searchTabConfig.tabAlias;
        parsedValues.templateId = searchTabConfig.directoryTemplateId;
        parsedValues.searchText = (rawValues.searchText || "").replace(/(\+)+/gi, " ").trim();

        if (rawValues.searchTab === SearchTabAlias.DIRECTORY_SEARCH) {
            parsedValues.sortOption = rawValues.sortOption || "Rank;asc";
            parsedValues.pageNumber = (rawValues.pageNumber > 0) ? Number(rawValues.pageNumber) : 1;
            parsedValues.pageSize = ((rawValues.pageSize > 0) && (rawValues.pageSize <= 100)) ? Number(rawValues.pageSize) : 10;

            if (parsedValues.sortOption.split(";").length !== 2) {
                parsedValues.sortOption = "Rank;asc";
            }

            parsedValues.categories = rawValues.categories || [];
            parsedValues.areas = rawValues.areas || [];
            parsedValues.postcode = rawValues.postcode || "";
            parsedValues.distance = rawValues.distance || "1609"; // 1 mile converted to meters
        } else {
            parsedValues.sortOption = "Rank;asc";
            parsedValues.pageNumber = 1;
            parsedValues.pageSize = 10;

            parsedValues.categories = [];
            parsedValues.areas = [];
            parsedValues.postcode = "";
            parsedValues.distance = "1609"; // 1 mile converted to meters
        }

        return parsedValues;
    }

    public serialiseToQueryString(searchParams: DirectorySearchParametersModel): string {
        return this._serializationService.serialize(searchParams);
    }
}
